<div class="info-card" [ngClass]="'variant-' + variant">
  @switch (variant) {
    @case ('progress') {
      <div class="card-content">
        <div class="title">{{ title }}</div>
        <div class="progress-row">
          <span class="progress-percent">{{ progress }}%</span>
          <span class="progress-label">{{ progressLabel }}</span>
        </div>
        <div class="progress-track">
          <div class="progress-fill" [style.width.%]="progress"></div>
        </div>
      </div>
    }
    @case ('plain') {
      <div class="card-content">
        <div class="title">{{ title }}</div>
        <div class="value">{{ value }}</div>
      </div>
    }
    @default {
      <div class="icon-wrapper" [style.background-color]="iconWrapperColor">
        <mat-icon class="icon" [style.color]="iconColor">{{ iconName }}</mat-icon>
      </div>
      <div class="card-content">
        <div class="title" [attr.id]="childTestId('title')">
          {{ title }}
          @if (canEdit) {
            <button
              type="button"
              class="inline-edit"
              [attr.data-testid]="childTestId('edit')"
              [matTooltip]="editTooltip"
              (click)="editStart.emit()"
            >
              <mat-icon>edit</mat-icon>
            </button>
          }
        </div>

        @if (editing) {
          <div class="edit-row">
            <div class="edit-input-group" [class.invalid]="error">
              <input
                type="number"
                class="edit-input"
                [attr.data-testid]="childTestId('input')"
                [attr.aria-labelledby]="childTestId('title')"
                [attr.aria-label]="title || 'Value'"
                [attr.aria-invalid]="!!error"
                [attr.min]="min"
                [attr.max]="max"
                [step]="step"
                [value]="draft"
                (input)="draftChange.emit($any($event.target).value)"
                (keydown.enter)="onEnter()"
                (keydown.escape)="cancelEdit.emit()"
              />
              @if (valueSuffix) {
                <span class="edit-suffix">{{ valueSuffix }}</span>
              }
            </div>

            <div class="edit-actions">
              <button
                type="button"
                class="edit-action confirm"
                aria-label="Save"
                [attr.data-testid]="childTestId('confirm')"
                matTooltip="Save"
                [disabled]="!!error"
                (click)="confirmEdit.emit()"
              >
                <mat-icon>check</mat-icon>
              </button>
              <button
                type="button"
                class="edit-action"
                aria-label="Cancel"
                [attr.data-testid]="childTestId('cancel')"
                matTooltip="Cancel"
                (click)="cancelEdit.emit()"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>

          @if (error) {
            <p class="edit-error" role="alert" [attr.data-testid]="childTestId('error')">
              <mat-icon>error</mat-icon>
              {{ error }}
            </p>
          }
        } @else {
          <div class="value" [attr.data-testid]="testId || null">
            @if (loading) {
              <ngx-skeleton-loader
                [ariaLabel]="title ? 'Loading ' + title : 'Loading'"
                appearance="line"
                [theme]="valueSkeleton"
              />
            } @else {
              {{ value }}{{ valueSuffix }}
            }
          </div>
        }
      </div>
    }
  }
</div>
